import { render, staticRenderFns } from "./DLXKZ.vue?vue&type=template&id=39e229db&scoped=true&"
import script from "./DLXKZ.vue?vue&type=script&lang=js&"
export * from "./DLXKZ.vue?vue&type=script&lang=js&"
import style0 from "./DLXKZ.vue?vue&type=style&index=0&id=39e229db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e229db",
  null
  
)

export default component.exports